import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

// Design tokens live here (Vuetify theme) and in src/styles/design-system.css (CSS variables).
export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#4d7082", // healthcare steel blue
        secondary: "#5B7C8D", // muted blue-gray
        accent: "#6b90a6",
        success: "#2E7D32",
        warning: "#E08A00",
        error: "#D32F2F",
        info: "#1976D2",
        background: "#F4F6F8",
      },
    },
  },
});
